module.exports = __webpack_public_path__ + "img/set_theme_9.5990dca1.png";